import { number, object } from '@/core/utils/validation';
import { pickingItemSchema, taskSchema } from './SocketMessageBase.yup';
const returnedFromBlockToStockMessageSchema = object({
    task: taskSchema.required(),
    pickingItem: pickingItemSchema.required(),
    blockedItem: object({
        id: number().integer().positive().required(),
        quantity: number().integer().min(0).required(),
    }).required(),
}).noUnknown(true);
export { returnedFromBlockToStockMessageSchema };
